import React, { useState, useEffect } from 'react';
import { api } from '../config/api';

// Ikony dla zakładek
const GeneralIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
  </svg>
);

const IntegrationsIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
  </svg>
);

const LimitsIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
  </svg>
);

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [usageData, setUsageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsageData = async () => {
      try {
        const data = await api.getUserUsage();
        setUsageData(data);
      } catch (error) {
        console.error('Błąd podczas pobierania danych o limitach:', error);
      } finally {
        setLoading(false);
      }
    };

    if (activeTab === 'limits') {
      fetchUsageData();
    }
  }, [activeTab]);

  const tabs = [
    { id: 'general', label: 'Ogólne', icon: <GeneralIcon /> },
    { id: 'integrations', label: 'Integracje', icon: <IntegrationsIcon /> },
    { id: 'limits', label: 'Limity', icon: <LimitsIcon /> }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'general':
        return (
          <div className="p-6">
            <h3 className="text-sm font-medium text-neutral-800 mb-4">Ustawienia ogólne</h3>
            <p className="text-xs text-neutral-500">Tutaj znajdziesz podstawowe ustawienia swojego konta.</p>
          </div>
        );
      case 'integrations':
        return (
          <div className="p-6">
            <h3 className="text-sm font-medium text-neutral-800 mb-4">Integracje</h3>
            <p className="text-xs text-neutral-500">Zarządzaj połączeniami z innymi serwisami.</p>
          </div>
        );
      case 'limits':
        return (
          <div className="p-6">
            <h3 className="text-sm font-medium text-neutral-800 mb-4">Limity</h3>
            <p className="text-xs text-neutral-500 mb-6">Ustaw limity i ograniczenia dla swojego konta.</p>

            {loading ? (
              <div className="text-sm text-neutral-500">Ładowanie...</div>
            ) : usageData ? (
              <div className="space-y-4">
                {usageData.map((limit) => (
                  <div key={limit.name} className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-medium text-neutral-700">
                        {limit.name === 'token_limit' ? 'Limit tokenów' : 'Limit list'}
                      </span>
                      <span className="text-sm text-neutral-500">
                        {limit.used} / {limit.limit}
                      </span>
                    </div>
                    <div className="w-full bg-neutral-100 rounded-full h-2">
                      <div
                        className="bg-primary-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${(limit.used / limit.limit) * 100}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-sm text-red-500">Nie udało się załadować danych o limitach.</div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex h-full md:pt-8 md:px-8">
      {/* Sidebar z zakładkami - tylko desktop */}
      <div className="w-48 hidden md:block">
        <nav className="space-y-1 pt-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center w-full px-6 py-2 text-xs rounded-md transition-colors ${
                activeTab === tab.id
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-neutral-600 hover:bg-neutral-50'
              }`}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Mobilny layout */}
      <div className="flex flex-col w-full md:hidden">
        {/* Mobilne menu z ikonkami */}
        <div className="flex space-x-8 py-4 px-4 border-b border-neutral-100">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`p-2 rounded-md transition-colors ${
                activeTab === tab.id
                  ? 'text-primary-600'
                  : 'text-neutral-600'
              }`}
            >
              {tab.icon}
            </button>
          ))}
        </div>

        {/* Mobilna zawartość */}
        <div className="flex-1">
          {renderContent()}
        </div>
      </div>

      {/* Desktop zawartość */}
      <div className="flex-1 min-w-0 hidden md:block">
        {renderContent()}
      </div>
    </div>
  );
};

export default SettingsPage; 